import type { CalculatorReport } from '#/modules/salary/types/CalculatorReport';
import type { EstimatedRange } from '#/modules/salary/types/EstimatedRange';
import type { SalariesReportFormData } from '#/modules/salary/types/SalariesReportFormData';
import type { SubmissionData } from '#/modules/salary/types/SubmissionData';
import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { waitTaskCompleted } from '#/utils/asyncBackendTask/waitTaskCompleted';
import { postJson } from '#/utils/http/postJson';

import { SALARIES_API_ENDPOINT_ROOT } from './salaryApiEndpointRoot';

async function fetchSubmissions(
  data: SalariesReportFormData,
): Promise<SubmissionData> {
  return postJson<{ submissionData: SubmissionData }>(
    `${SALARIES_API_ENDPOINT_ROOT}/calculator/submissions`,
    data,
  ).then(({ submissionData }) => submissionData);
}

async function fetchEstimatedRange(
  data: SalariesReportFormData,
): Promise<BackgroundTask<{ estimatedRange: EstimatedRange }>> {
  return postJson<{
    task: BackgroundTask<{ estimatedRange: EstimatedRange }>;
  }>(`${SALARIES_API_ENDPOINT_ROOT}/calculator/estimated-range`, data).then(
    ({ task }) => task,
  );
}

export async function salaryApiFetchReport(
  values: SalariesReportFormData,
): Promise<CalculatorReport> {
  const [submissionData, reportTask] = await Promise.all([
    fetchSubmissions(values),
    fetchEstimatedRange(values),
  ]);

  const { estimatedRange } = await waitTaskCompleted(reportTask);
  return { submissionData, estimatedRange };
}
